// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__qz4bC","slice":"styles_slice__EdHC9"};